import { ABORT_ERROR} from '@mimir/common/util/abortControl';
import { makeError } from '@mimir/common/util/exception';

export function throwIfAborted(abortSignal: AbortSignal) {
  if (abortSignal.aborted) {
    throw makeError('Aborted', ABORT_ERROR, { cause: abortSignal.reason });
  }
}


